import { render } from "./StepComms.vue?vue&type=template&id=efe3f55e&scoped=true"
import script from "./StepComms.vue?vue&type=script&lang=js"
export * from "./StepComms.vue?vue&type=script&lang=js"

import "./StepComms.vue?vue&type=style&index=0&id=efe3f55e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efe3f55e"]])

export default __exports__